<template lang="pug">
#compartilhamentoDados
    BaseHeader(
        titulo='Relatório de Compartilhamento de Dados',
        icon='el-icon-plus',
        btnTexto='Novo Relatório',
        :exibeBotao='true',
        @btnHeaderClicado='changeShowModalSelecionarTerritorio'
    )

    .view-container-base-header
        Filtros(@getFiltrosCompart='filtrar')

        .lista
            CompartilhamentoDadosListagem(
                :key="listagemTableKey('compartilhamento', compartilhamentoDados, pageParams.page)",
                v-if='usuario.isAdmin',
                :tableData='compartilhamentoDados',
                @handleSort='handleSort'
            )

            .py-3(style='text-align: center')
                el-pagination(
                    background,
                    :page-size='pageParams.size',
                    :current-page.sync='pageParams.page',
                    layout='prev, pager, next',
                    :total='totalCompartilhamentoDados',
                    @current-change='requestCompartilhamentoDados'
                )

    el-dialog.ajuste-visualizacao(
        title='Selecione um ou mais territórios para solicitação de compartilhamento de dados',
        :visible.sync='showModalSelecionarTerritorios',
        close='changeShowModalSelecionarTerritorios'
    )
        SelecionarTerritorio(
            @getIdsTerritoriosSelecionados='solicitarCompartilhamentoDados',
            ref='selecionarTerritorio'
        )

    Footer
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import Filtros from '@/components/compartilhamentoDados/Filtros.vue';
import CompartilhamentoDadosListagem from '@/components/compartilhamentoDados/CompartilhamentoDadosListagem.vue';
import SelecionarTerritorio from '@/components/compartilhamentoDados/SelecionarTerritorio.vue';

import CompartilhamentoDadosService from '@/services/CompartilhamentoDadosService';
import { connect, subscribe, disconnect } from '@/utils/websocket';

export default {
    name: 'index',
    components: {
        BaseHeader,
        SelecionarTerritorio,
        CompartilhamentoDadosListagem,
        Filtros
    },
    async mounted() {
        await connect();

        let user = sessionStorage.getItem('dadosUsuario');
        if (user) {
            user = JSON.parse(user);
            subscribe(
                `${user.idKeyCloack}/compartilhamento-dados/gerar/excel`,
                response => {
                    const compartilhamentoDadosProcessado =
                        JSON.parse(response);
                    const compartilhamentoDadosSelecionado =
                        this.compartilhamentoDados.find(
                            p => p.id === compartilhamentoDadosProcessado.id
                        );
                    if (compartilhamentoDadosSelecionado) {
                        compartilhamentoDadosSelecionado.situacaoNome =
                            compartilhamentoDadosProcessado.situacaoNome;
                        compartilhamentoDadosSelecionado.situacaoCompartilhamentoDados =
                            compartilhamentoDadosProcessado.situacaoCompartilhamentoDados;
                    }
                }
            );
        } else {
            this.$notify.error({
                message: 'Usuário deslogado!'
            });
        }
    },
    beforeDestroy() {
        disconnect();
    },
    computed: {
        usuario() {
            return this.$store.state.usuarioLogado;
        }
    },
    data() {
        return {
            showModalSelecionarTerritorios: false,
            showModalConfirmarTerritorios: false,
            territoriosSelecionados: [],
            pageParams: {
                page: 1,
                size: 20,
                sort: 'dataCadastro,DESC'
            },
            filtros: {
                idsUsuarios: [],
                situacao: null,
                dataCadastroInicio: '',
                dataCadastroFim: ''
            },
            totalCompartilhamentoDados: 0,
            compartilhamentoDados: [],
            idCompartilhamentoDados: null,
            rowInfo: null,
            showModalInsercaoResultados: false,
            usuariosBuffer: {}
        };
    },
    methods: {
        changeShowModalSelecionarTerritorio() {
            this.showModalSelecionarTerritorios =
                !this.showModalSelecionarTerritorios;
        },

        solicitarCompartilhamentoDados(idsTerritoriosSelecionados) {
            this.$router.push({
                name: 'CompartilhamentoDadosSolicitacao',
                params: { idsTerritorio: idsTerritoriosSelecionados }
            });
        },

        voltar() {
            this.changeShowModalConfirmarTerritorios();
            this.requestCompartilhamentoDados();
        },
        handleSort(paramsProp) {
            this.pageParams = {
                page: this.pageParams.page,
                size: 20,
                sort: `${paramsProp.column},${paramsProp.order}`
            };
            this.requestCompartilhamentoDados();
        },
        filtrar(filtros) {
            this.filtros = { ...filtros };
            this.requestCompartilhamentoDados();
        },

        async requestCompartilhamentoDados() {
            const { data, status } =
                await CompartilhamentoDadosService.requestCompartilhamentoDados(
                    this.filtros,
                    this.pageParams
                );
            if (status === 200) {
                this.totalCompartilhamentoDados = data.totalItens;
                this.compartilhamentoDados = data.compartilhamentosDados;
            } else {
                this.$notify.error({
                    message: 'Não foi possível carregar os dados.'
                });
            }
        }
    }
};
</script>

<style scoped lang="scss">
#compartilhamentoDados {
    height: 100%;
    width: 100%;

    .compart-btn {
        justify-content: flex-end;
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .m-top {
        margin-top: 25px;
    }
}
</style>
